import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, createSlots as _createSlots } from "vue"
import _imports_0 from '@/assets/classroom_sync.png'


const _hoisted_1 = { class: "relative flex flex-col flex-grow" }
const _hoisted_2 = { class: "flex items-center pb-4 pt-1.5 mb-2" }
const _hoisted_3 = { class: "overflow-hidden mr-4" }
const _hoisted_4 = {
  class: "mb-0",
  style: {"line-height":"0.95","white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
}
const _hoisted_5 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_6 = { class: "chip chip-primary mb-0" }
const _hoisted_7 = { class: "flex items-center mx-auto" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 material-icons text-primary" }, "people", -1)
const _hoisted_9 = { class: "text-primary" }
const _hoisted_10 = { class: "ml-1 text-sm text-muted text-primary" }
const _hoisted_11 = { class: "chip chip-success mb-0" }
const _hoisted_12 = { class: "flex items-center mx-auto" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 material-icons-outlined text-success" }, "assignment_turned_in", -1)
const _hoisted_14 = { class: "text-success" }
const _hoisted_15 = { class: "ml-1 text-sm text-muted text-success" }
const _hoisted_16 = { class: "chip bg-light border-none mb-0" }
const _hoisted_17 = { class: "flex items-center mx-auto" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("p", null, "%", -1)
const _hoisted_19 = { class: "ml-1 text-sm text-center text-muted" }
const _hoisted_20 = { class: "flex items-center mb-1" }
const _hoisted_21 = { class: "flex items-center space-x-2 w-1/3 mr-auto" }
const _hoisted_22 = {
  style: {"width":"22px","height":"22px"},
  class: "opacity-70",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("title", null, "sort", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", { d: "M18 21L14 17H17V7H14L18 3L22 7H19V17H22M2 19V17H12V19M2 13V11H9V13M2 7V5H6V7H2Z" }, null, -1)
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = { class: "-mx-5 -my-2.5 w-max" }
const _hoisted_27 = {
  key: 0,
  class: "material-icons mr-2 text-primary"
}
const _hoisted_28 = { class: "flex items-center align-top" }
const _hoisted_29 = {
  key: 0,
  class: "flex mr-2"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {"width":"28px"}
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", {
  id: "insights-btn",
  class: "transition-opacity duration-75 rounded-full material-icons-outlined"
}, "insights", -1)
const _hoisted_32 = {
  key: 1,
  class: "flex mr-2 items-center"
}
const _hoisted_33 = { class: "text-muted mr-1" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "mr-1 text-base material-icons-outlined" }, " block ", -1)
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "w-full mb-4 banner banner-danger" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "text-yellow-900 material-icons-outlined" }, " error_outline ", -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"17px !important","margin-right":"0 !important"}
}, "close", -1)
const _hoisted_39 = { key: 1 }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "ml-px text-yellow-900 material-icons-outlined" }, " pending_actions ", -1)
const _hoisted_41 = { class: "" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "text-base text-yellow-900 inline-icon material-icons-outlined" }, "pending_actions", -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"17px !important","margin-right":"3px !important"}
}, "close", -1)
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", { class: "ml-px material-icons-outlined text-success" }, " task ", -1)
const _hoisted_45 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"17px !important","margin-right":"0 !important"}
}, "close", -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("span", { class: "text-xl material-icons-outlined" }, " done ", -1)
const _hoisted_47 = { class: "" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", {
  class: "material-icons-outlined",
  style: {"font-size":"17px !important","margin-right":"0 !important"}
}, "close", -1)
const _hoisted_49 = { class: "flex-grow" }
const _hoisted_50 = {
  key: 0,
  class: "text-darkText"
}
const _hoisted_51 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_DropdownMenu = _resolveComponent("DropdownMenu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CsvParticipationDownloader = _resolveComponent("CsvParticipationDownloader")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_IntegrationSwitch = _resolveComponent("IntegrationSwitch")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_AbstractEventParticipationSlot = _resolveComponent("AbstractEventParticipationSlot")!
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_v_tour = _resolveComponent("v-tour")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", _hoisted_4, _toDisplayString(_ctx.event.name), 1)
      ]),
      (!_ctx.firstLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.participantCount), 1),
                _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("event_monitor.stats_participants")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.turnedInCount), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("event_monitor.stats_turned_in")), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("p", null, _toDisplayString(_ctx.averageProgress), 1),
                _hoisted_18,
                _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$t("event_monitor.stats_average_progress")), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createVNode(_component_TextInput, {
          searchBar: true,
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          leftIcon: 'search',
          class: "w-full",
          placeholder: _ctx.$t('event_monitor.search_students')
        }, null, 8, ["modelValue", "placeholder"]),
        _createVNode(_component_DropdownMenu, {
          expanded: _ctx.sortingOptionsExpanded,
          onToggleExpanded: _cache[1] || (_cache[1] = ($event: any) => (_ctx.sortingOptionsExpanded = !_ctx.sortingOptionsExpanded))
        }, {
          activator: _withCtx(() => [
            _createVNode(_component_Btn, {
              variant: 'icon',
              outline: true,
              class: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock("svg", _hoisted_22, _hoisted_25))
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortingOptions, (option, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createVNode(_component_Btn, {
                    outline: true,
                    class: "px-8 pt-2 pb-2 w-full",
                    variant: 'transparent',
                    onClick: ($event: any) => (_ctx.setSortingOption(index))
                  }, {
                    default: _withCtx(() => [
                      (index === _ctx.selectedSortingOption)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "done"))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(option.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["expanded"])
      ]),
      (!_ctx.firstLoading && _ctx.resultsMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createVNode(_component_Btn, {
              class: "no-elevate mr-2",
              onClick: _ctx.onPublishResults,
              disabled: _ctx.selectedParticipationsIds.length == 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("event_results.publish_results")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "disabled"]),
            (_ctx.googleClassroomCourseWorkTwin !== null)
              ? (_openBlock(), _createBlock(_component_Btn, {
                  key: 0,
                  variant: 'icon',
                  outline: true,
                  tooltip: _ctx.$t('integrations.classroom.sync_grades_with_classroom'),
                  onClick: _ctx.onSyncGradesWithClassroom
                }, {
                  default: _withCtx(() => [
                    _hoisted_30
                  ]),
                  _: 1
                }, 8, ["tooltip", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              class: "z-50",
              to: { name: 'ExamStats' }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Btn, {
                  outline: true,
                  tooltip: _ctx.$t('help_texts.stats'),
                  variant: 'icon',
                  class: "transition-transform duration-200 transform icon-btn-primary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_31
                  ]),
                  _: 1
                }, 8, ["tooltip"])
              ]),
              _: 1
            }),
            _createVNode(_component_CsvParticipationDownloader, { class: "ml-auto" })
          ]))
        : (!_ctx.firstLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.$t("event_monitor.if_selected")) + ":", 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.entries(_ctx.bulkActions), ([name, action]) => {
                return (_openBlock(), _createElementBlock("div", { key: name }, [
                  _createVNode(_component_Btn, {
                    onClick: ($event: any) => (action.method()),
                    class: "no-elevate mx-1",
                    variant: 'secondary',
                    disabled: !_ctx.selectedParticipations.some(p => action.applicable(p))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(action.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "disabled"])
                ]))
              }), 128)),
              _createVNode(_component_Btn, {
                outline: true,
                size: 'sm',
                variant: 'danger',
                onClick: _ctx.onCloseExam,
                class: "ml-4 mr-1"
              }, {
                default: _withCtx(() => [
                  _hoisted_34,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("event_preview.close")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true)
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
          (_ctx.event.state === _ctx.EventState.RESTRICTED)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["flex w-full transition-all duration-200", {
					'opacity-0 max-h-0 mb-0': !_ctx.showRestrictedModeBanner,
					'opacity-100 max-h-96 mb-3': _ctx.showRestrictedModeBanner,
				}])
              }, [
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t("event_monitor.some_exams_still_open")), 1),
                  _createVNode(_component_Btn, {
                    outline: true,
                    size: 'xs',
                    variant: 'icon',
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showRestrictedModeBanner = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 1
                  })
                ])
              ], 2))
            : _createCommentVNode("", true),
          (!_ctx.firstLoading && _ctx.resultsMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                (!_ctx.areAllParticipationsFullyAssessed(_ctx.mainStore.eventParticipations))
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["flex transition-all duration-200 banner banner-danger", {
						'opacity-0 max-h-0 mb-0 py-0': !_ctx.showThereArePendingAssessmentsBanner,
						'opacity-100 max-h-96 mb-3': _ctx.showThereArePendingAssessmentsBanner,
					}])
                    }, [
                      _hoisted_40,
                      _createElementVNode("p", _hoisted_41, [
                        _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.some_exams_require_manual_assessment")) + " " + _toDisplayString(_ctx.$t("event_assessment.exams_awaiting_assessment_are_marked")) + " ", 1),
                        _hoisted_42,
                        _createTextVNode(". ")
                      ]),
                      _createVNode(_component_Btn, {
                        outline: true,
                        size: 'xs',
                        variant: 'icon',
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showThereArePendingAssessmentsBanner = false))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_43
                        ]),
                        _: 1
                      })
                    ], 2))
                  : (_ctx.thereAreUnpublishedAssessments)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: _normalizeClass(["flex transition-all duration-200 banner banner-light", {
						'opacity-0 max-h-0 mb-0 py-0': !_ctx.showThereAreUnpublishedResultsBanner,
						'opacity-100 max-h-96 mb-3': _ctx.showThereAreUnpublishedResultsBanner,
					}])
                      }, [
                        _hoisted_44,
                        _createElementVNode("p", null, [
                          _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.ready_to_publish_1")) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("event_results.publish_results")), 1),
                          _createTextVNode(". " + _toDisplayString(_ctx.$t("event_assessment.ready_to_publish_2")), 1)
                        ]),
                        _createVNode(_component_Btn, {
                          outline: true,
                          size: 'xs',
                          variant: 'icon',
                          style: {"margin-left":"auto !important"},
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showThereAreUnpublishedResultsBanner = false))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        })
                      ], 2))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["flex transition-all duration-200 banner banner-success", {
						'opacity-0 max-h-0 mb-0 py-0': !_ctx.showAllAssessmentsPublishedBanner,
						'opacity-100 max-h-96 mb-3': _ctx.showAllAssessmentsPublishedBanner,
					}])
                      }, [
                        _hoisted_46,
                        _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.$t("event_assessment.all_published")), 1),
                        _createVNode(_component_Btn, {
                          outline: true,
                          size: 'xs',
                          variant: 'icon',
                          style: {"margin-left":"auto !important"},
                          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAllAssessmentsPublishedBanner = false))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_48
                          ]),
                          _: 1
                        })
                      ], 2))
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_49, [
      _createVNode(_component_DataTable, {
        class: _normalizeClass({
					'opacity-50': _ctx.filteredParticipationsData.length === 0 || _ctx.firstLoading,
				}),
        columnDefs: _ctx.participationPreviewColumns,
        rowData: _ctx.firstLoading ? [] : _ctx.filteredParticipationsData,
        isRowSelectable: _ctx.isRowSelectable,
        rowClassRules: _ctx.getRowClassRules(),
        getRowId: _ctx.getRowId,
        onCellClicked: _ctx.onCellClicked,
        onGridReady: _cache[6] || (_cache[6] = ($event: any) => {
					_ctx.gridApi = $event.api;
					_ctx.columnApi = $event.columnApi;
					_ctx.columnApi.autoSizeAllColumns(false);
				}),
        onSelectionChanged: _ctx.onSelectionChanged
      }, null, 8, ["class", "columnDefs", "rowData", "isRowSelectable", "rowClassRules", "getRowId", "onCellClicked", "onSelectionChanged"])
    ]),
    (_ctx.blockingDialogData)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 1,
          showDialog: _ctx.showBlockingDialog,
          onNo: _cache[8] || (_cache[8] = ($event: any) => (_ctx.resolveBlockingDialog(false))),
          onYes: _cache[9] || (_cache[9] = ($event: any) => (_ctx.resolveBlockingDialog(true))),
          noText: _ctx.blockingDialogData.noText,
          yesText: _ctx.dispatchingCall ? _ctx.$t('misc.wait') : _ctx.blockingDialogData.yesText,
          dismissible: true,
          disableOk: _ctx.blockingDialogData.disableOk || _ctx.dispatchingCall
        }, _createSlots({
          body: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.blockingDialogData.text), 1)
          ]),
          footerButtons: _withCtx(() => [
            (_ctx.showClassroomIntegrationSwitch)
              ? (_openBlock(), _createBlock(_component_IntegrationSwitch, {
                  key: 0,
                  class: "ml-7.5 mb-1",
                  modelValue: _ctx.publishToClassroom,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.publishToClassroom) = $event))
                }, null, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, [
          (_ctx.blockingDialogData.title)
            ? {
                name: "title",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.blockingDialogData.title), 1)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["showDialog", "noText", "yesText", "disableOk"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      warning: !_ctx.resultsMode && !_ctx.editingSlot,
      fullWidth: !!_ctx.editingSlot,
      showDialog: _ctx.showAssessmentEditorDialog,
      onNo: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showAssessmentEditorDialog = false)),
      onYes: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dispatchAssessmentUpdate())),
      noText: _ctx.dialogData.noText,
      yesText: 
				_ctx.dispatchingCall ? _ctx.$t('misc.wait') : _ctx.$t('event_assessment.confirm_assessment')
			,
      dismissible: false,
      footerBorder: true,
      disableOk: 
				_ctx.dispatchingCall ||
				(_ctx.editingSlotDirty &&
					(_ctx.editingSlotDirty.score == null || _ctx.editingSlotDirty.score.length == 0))
			
    }, _createSlots({
      body: _withCtx(() => [
        (_ctx.editingSlot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
              (!_ctx.localLoading && _ctx.editingSlotDirty)
                ? (_openBlock(), _createBlock(_component_AbstractEventParticipationSlot, {
                    key: 0,
                    allowEditAssessment: true,
                    showAssessmentCard: true,
                    assessmentWriteOnly: true,
                    modelValue: _ctx.editingSlotDirty,
                    onOpenFull: _cache[10] || (_cache[10] = ($event: any) => (
							_ctx.$router.push({
								name: 'ExamParticipationFull',
								params: { participationId: _ctx.editingParticipationId },
							})
						)),
                    onUpdateAssessment: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onUpdateSlotAssessment($event)))
                  }, null, 8, ["modelValue"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_51, [
                    _createVNode(_component_SkeletonCard, { borderLess: true }),
                    _createVNode(_component_SkeletonCard, { borderLess: true })
                  ]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (_ctx.editingSlot)
        ? {
            name: "title",
            fn: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("event_assessment.assess")) + " " + _toDisplayString(_ctx.$t("event_assessment.exercise")) + " " + _toDisplayString((_ctx.editingSlot?.slot_number ?? 0) + 1) + " " + _toDisplayString(_ctx.$t("misc.for")) + " " + _toDisplayString(_ctx.editingFullName), 1)
            ]),
            key: "0"
          }
        : (_ctx.dialogData.title?.length > 0)
          ? {
              name: "title",
              fn: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.dialogData.title), 1)
              ]),
              key: "1"
            }
          : undefined
    ]), 1032, ["warning", "fullWidth", "showDialog", "noText", "yesText", "disableOk"]),
    (_ctx.firstLoading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 2,
          style: {"z-index":"99999999"},
          variant: 'dark',
          fast: true,
          size: 'xl',
          class: "absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_tour, {
      name: "examInsightsTour",
      steps: _ctx.examInsightsPageTourSteps,
      options: _ctx.tourOptions
    }, null, 8, ["steps", "options"])
  ]))
}